import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getMimeFromFile } from '../helpers/base-get-mime-type-by-file-name';
import { AllowedMimeTypes } from '../constants/base-file-types';

export const baseFiletypeValidator = (
  allowedFileTypes: ReadonlySet<string> = AllowedMimeTypes,
  errorKey: string = 'fileTypeInvalid'
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!(value instanceof File)) {
      return null;
    }

    const mimeToCheck = getMimeFromFile(value);

    return allowedFileTypes.has(mimeToCheck) ? null : { [errorKey]: true };
  };
};
